export const cacheTags = {
    EVENTS: 'Events',
    USERS: 'Users',
    CITIES: 'Cities',
    HOTELS: 'Hotels',
    ROOMS: 'Rooms',
    CUSTOMERS: 'Customers',
    INDUSTRIES: 'Industries',
    SEGMENTS: 'Segments'
}